import { Injectable, Signal, signal } from '@angular/core';

/**
 * Tracks whether the legacy activity editor side panel is open while the library dialog is showing.
 * We use a service so children that trigger the editor can update the state even if Angular destroys them.
 */
@Injectable()
export class LibraryActivityPanelStateService {
	private readonly panelOpenSignal = signal(false);

	public readonly panelOpen: Signal<boolean> = this.panelOpenSignal.asReadonly();

	public setIsOpen (isOpen: boolean): void {
		this.panelOpenSignal.set(isOpen);
	}
}
